import React from "react";

import { useRecoilValue } from "recoil";
import { toastListState } from "lib/store/common";

import { Toast } from "./Toast";

import "./ToastWrapper.scss";

export type ToastWrapperProps = {
  cx?: string;
};

export const ToastWrapper: React.FC<ToastWrapperProps> = ({ cx = "" }) => {
  const toast = useRecoilValue(toastListState);
  return (
    <div className={`ToastWrapper ${cx}`}>
      {toast.map(({ text, type, idx }) => (
        <Toast type={type} idx={idx} key={`toast-${idx}`}>
          {text}
        </Toast>
      ))}
    </div>
  );
};
